import { Component, Prop, Vue } from 'vue-property-decorator';

type Position = 'start' | 'end';

@Component
export default class ClInputAdornment extends Vue {
  @Prop({
    required: true,
    type: String as () => Position,
    validator: x => ['start', 'end'].includes(x)
  })
  public position!: Position;
}
